import { CardShortInfoOrganization } from '../card-short-info-organization/card-short-info-organization';
import { Typography } from '../../../../shared/ui/typography/typography';
import { COLORS } from '../../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    border-radius: 20px;
    flex-direction: column;
    background-color: ${COLORS.neutral_00};
`;

export const OrganizationWrapper = styled('div')`
    position: relative;
`;

export const CardOrganization = styled(CardShortInfoOrganization)`
    margin-top: 20px;
    align-self: flex-start;
`;

export const AccordionTitle = styled(Typography)`
    margin-right: 8px;
`;

export const FormContent = styled('div')`
    display: flex;
    margin-top: 20px;
    gap: 20px;
    flex-direction: column;
`;

export const RequisitieFields = styled('div')`
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
`;

export const ContactFields = styled('div')`
    display: grid;
    gap: 20px;
    grid-template-columns: 1fr 1fr;
`;

export const InputsFIO = styled('div')`
    display: grid;
    grid-column-start: 1;
    grid-column-end: -1;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
`;

export const InputsGroup = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
